// extracted by mini-css-extract-plugin
export default {"card":"PublicTripCard_card__KHGYW","title":"PublicTripCard_title__OuWGN","body":"PublicTripCard_body__rtmfr","action":"PublicTripCard_action__2ZKln"};